import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const EmailAuthForm = ({ onSuccess, testPrefix = "auth" }) => {
  const { setUser } = useAuth();
  const [mode, setMode] = useState("signin");
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = mode === "register"
        ? { name: form.name, email: form.email, phone: form.phone, password: form.password }
        : { email: form.email, password: form.password };
      await api.post(mode === "register" ? "/auth/register" : "/auth/login", payload);
      const me = await api.get("/auth/me");
      setUser(me.data);
      toast.success(mode === "register" ? "Account created — welcome!" : "Signed in!");
      onSuccess?.(me.data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={`${testPrefix}-email-form`}>
      <div className="flex rounded-lg bg-muted p-1 text-sm">
        <button type="button" onClick={() => setMode("signin")} data-testid={`${testPrefix}-tab-signin`}
          className={`flex-1 py-1.5 rounded-md font-medium transition-colors ${mode === "signin" ? "bg-background shadow text-primary" : "text-muted-foreground"}`}>Sign In</button>
        <button type="button" onClick={() => setMode("register")} data-testid={`${testPrefix}-tab-register`}
          className={`flex-1 py-1.5 rounded-md font-medium transition-colors ${mode === "register" ? "bg-background shadow text-primary" : "text-muted-foreground"}`}>Register</button>
      </div>
      <form onSubmit={submit} className="mt-3 space-y-3 text-left">
        {mode === "register" && (
          <div><Label className="text-xs">Full Name</Label>
            <Input required value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="e.g. Rahul Verma" data-testid={`${testPrefix}-name-input`} /></div>
        )}
        <div><Label className="text-xs">Email</Label>
          <Input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="you@email.com" data-testid={`${testPrefix}-email-input`} /></div>
        {mode === "register" && (
          <div><Label className="text-xs">Phone</Label>
            <Input required value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="+91 ..." data-testid={`${testPrefix}-phone-input`} /></div>
        )}
        <div><Label className="text-xs">Password</Label>
          <Input required type="password" minLength={6} value={form.password} onChange={(e) => set("password", e.target.value)}
            placeholder={mode === "register" ? "At least 6 characters" : "Your password"} data-testid={`${testPrefix}-password-input`} /></div>
        <Button type="submit" disabled={loading} className="w-full h-10 bg-primary hover:bg-primary/90 gap-2" data-testid={`${testPrefix}-email-submit-button`}>
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}{mode === "register" ? "Create Account" : "Sign In"}
        </Button>
      </form>
    </div>
  );
};
